// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608200604/js/" + chunkId + "." + {"44":"7053de36","225":"a93c4911","481":"63ca4340","486":"b498f081","770":"f4e78d9a"}[chunkId] + ".0.4635129634645332.chunk.js";
};